"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResearchActivities = exports.DocumentationTools = void 0;
var DocumentationTools;
(function (DocumentationTools) {
    DocumentationTools["EMPLOYEE_CALENDARS"] = "Employee Calendars";
    DocumentationTools["MEETING_AGENDAS"] = "Meeting Agendas";
    DocumentationTools["EMAILS"] = "E-mails";
    DocumentationTools["MEETING_MINUTES"] = "Meeting Minutes";
    DocumentationTools["GANTT_CHARTS"] = "Gantt Charts";
    DocumentationTools["PROJECT_MANAGEMENT_SOFTWARE"] = "Project Management Software";
    DocumentationTools["ARCHITECTURE_DIAGRAMS"] = "Architecture Diagrams";
    DocumentationTools["PROTOTYPE_BUILD_SHEETS"] = "Prototype Build Sheets";
    DocumentationTools["COMPUTATIONAL_DOCUMENTS"] = "Computational Documents";
    DocumentationTools["PROCESS_CHARTS"] = "Process Charts";
    DocumentationTools["DESIGN_PROTOTYPES"] = "Design Prototypes";
    DocumentationTools["CONCEPT_DRAWINGS"] = "Concept Drawings";
    DocumentationTools["MOCKUPS"] = "Mockups";
    DocumentationTools["SOFTWARE_SOURCE_CODE"] = "Software Source Code";
    DocumentationTools["COMMIT_LOGS"] = "Commit Logs";
    DocumentationTools["PULL_REQUESTS"] = "Pull Requests";
    DocumentationTools["CLOUD_COMPUTING"] = "Cloud Computing Usage Records";
    DocumentationTools["RELEASE_NOTES"] = "Release Notes";
    DocumentationTools["API_USAGE"] = "API Usage Logs";
    DocumentationTools["API_DOCS"] = "API Documentation";
    DocumentationTools["LAB_TESTS"] = "Lab Test Results";
})(DocumentationTools || (exports.DocumentationTools = DocumentationTools = {}));
var ResearchActivities;
(function (ResearchActivities) {
    ResearchActivities["RESEARCH_PAPERS"] = "Research Papers/Drafts";
    ResearchActivities["WHITE_PAPERS"] = "White Papers";
    ResearchActivities["PATENTS"] = "Patents";
})(ResearchActivities || (exports.ResearchActivities = ResearchActivities = {}));
